import { Heading } from '@astryxdesign/core/Heading';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import { Phone } from '@phosphor-icons/react';
import type { Studio } from '@/api/schemas';
import { GlassSurface } from '@/components/GlassSurface';
import { fmtPhoneHref } from '@/lib/format';
import { mediaUrl } from '@/lib/supabase';

/**
 * Full-bleed hero. The glass "Записаться" button is sticky inside the hero,
 * so it travels with the photo; its lens only snapshots #hero-media.
 */
export function Hero({ studio, onBook }: { studio: Studio; onBook: () => void }) {
  const hero = mediaUrl(studio.settings.heroImagePath);
  const logo = mediaUrl(studio.settings.logoPath);
  return (
    <header className="hero">
      <div id="hero-media" className="hero__media" aria-hidden>
        {hero && <img src={hero} alt="" crossOrigin="anonymous" fetchPriority="high" decoding="async" />}
        <span className="hero__shade" />
      </div>
      <VStack gap={3} className="hero__content">
        {logo && <img className="hero__logo" src={logo} alt={`Логотип ${studio.settings.name}`} width={56} height={56} crossOrigin="anonymous" />}
        <Heading level={1} type="display-2" textWrap="balance">
          {studio.settings.name}
        </Heading>
        {studio.settings.tagline && (
          <Text type="large" color="secondary" textWrap="pretty">
            {studio.settings.tagline}
          </Text>
        )}
        <GlassSurface snapshot="#hero-media" zIndex={20} className="hero-cta">
          <button type="button" className="hero-cta__button" onClick={onBook}>
            Записаться
          </button>
        </GlassSurface>
        <a className="hero__call" href={fmtPhoneHref(studio.settings.phone)}>
          <Phone size={18} aria-hidden /> {studio.settings.phone}
        </a>
      </VStack>
    </header>
  );
}
